import React from 'react';
import MLSnsWrapper from '../Common/MLSnsWrapper';
import FooterInfo from './FooterInfo';
import VlendingLogo from '../Common/VlendingLogo';
import Copyright from './Copyright';
import TermsPrivacyWrapper from './TermsPrivacyWrapper';

const MLFooter = () => {
  return (
    <footer className={'ml-footer'}>
      <div className={'ml-footer-inner'}>
        <div className='ml-footer-layout-wrapper'>
          <div className='ml-footer-top-wrapper'>
            <VlendingLogo />
            <MLSnsWrapper />
          </div>
          <div className='ml-footer-bottom-wrapper'>
            <TermsPrivacyWrapper />
            <FooterInfo />
            <Copyright />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MLFooter;
